<style lang="less" scoped>
  .body {
    height: calc(100% - 50px);
  }
  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;
  }
  .input-group {
    display: flex;
    align-items: flex-start;
    margin: 5px 0;
  }
  .input-group-left {
    width: 75px;
    height: 40px;
  }
  .label {
    line-height: 40px;
    color: #808080;
  }
  .input-group-right {
    width: 150px;
    margin-left: 18px;
  }
  .button {
    width: 150px;
    margin-top: 10px;
    border-color: #ff6c00;
    color: #ff6c00;
  }
  .search-result-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 75px;
  }
  .username {
    margin-top: 19px;
    font-weight: bold;
    color: #ff6c00;
    font-size: 20px;
  }
  .email {
    color: #ff6c00;
  }
</style>

<style lang="less">
  .sc-find-account-dialog {
    width: 392px;
    height: 311px;
    box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.1);
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      height: 100%;
    }
  }
</style>

<template lang="pug">
  el-dialog(
    :visible="visible",
    custom-class="sc-find-account-dialog",
    :append-to-body="true",
    @close="close")
    sc-tabs(:currentTab="currentTab", :tabs="tabs", @change="changeTab")
    .body(v-if="currentTab === 'username'")
      form.form(v-if="!searchedUsername", @submit.prevent="searchUsername")
        .input-group
          .input-group-left
            label.label 사업자 번호
          .input-group-right
            el-input(placeholder="사업자 번호", v-model="businessNumber")
            el-button.button(native-type="submit") 아이디 찾기
      .search-result-content(v-else)
        p 해당 사업자 번호로 가입한 아이디
        strong.username {{ searchedUsername }}
    .body(v-else)
      form.form(v-if="!sentEmail", @submit.prevent="findPassword")
        .input-group
          .input-group-left
            label.label 아이디
          .input-group-right
            el-input(placeholder="아이디", v-model="username")
        .input-group
          .input-group-left
            label.label 사업자 번호
          .input-group-right
            el-input(placeholder="사업자 번호", v-model="businessNumber")
            el-button.button(native-type="submit") 비밀번호 찾기
      .search-result-content(v-else)
        p.
          가입 시 등록하신 #[span.email {{sentEmail}}]으로#[br]
          임시 비밀번호를 발송하였습니다.
</template>

<script>
import ScTabs from '@/components/ScTabs.vue';

export default {
  components: {
    ScTabs,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: String,
      default: 'username', // 'username', 'password'
    },
    searchedUsername: {
      type: String,
    },
    sentEmail: {
      type: String,
    },
  },
  data() {
    return {
      username: null,
      businessNumber: null,
      tabs: [
        { value: 'username', label: '아이디 찾기' },
        { value: 'password', label: '비밀번호 찾기' },
      ],
    };
  },
  methods: {
    close() {
      this.businessNumber = null;
      this.$emit('close');
    },
    changeTab(tabName) {
      this.businessNumber = null;
      this.$emit('changeTab', tabName);
    },
    searchUsername() {
      this.$emit('searchUsername', this.businessNumber);
    },
    findPassword() {
      this.$emit('findPassword', {
        businessNumber: this.businessNumber,
        username: this.username,
      });
    },
  },
};
</script>
